
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2023
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Dashboard maken',
	'dashboard': 'Dashboard',
	'dashboardTemplate': 'Dashboardsjabloon',
	'createAV': 'Maken',
	'createAvEditNameLabel': '1. Geef uw view een naam',
	'createAvSelectTemplateLabel': '2. Selecteer een sjabloon',
	'tabLayoutLabel': 'Sjabloon met tabbladen',
	'infographicsLayoutLabel': 'Infographic-sjabloon',
	'singlePageLayoutLabel': 'Sjabloon met enkele pagina',
	'customLayoutLabel': 'Aangepaste sjabloon',
	'freeformTemplate': 'Vrije vorm',
	'freeformTemplateDesc': 'Visualisaties in een een vrije-vorm layout worden exact hetzelfde weergegeven als hoe u deze in de view plaatst, ongeacht de schermgrootte. In de andere indelingen worden de grootte en positie van de visualisaties aangepast aan de grootte van het scherm.',
	'NoTemplate': 'Vrije vorm',
	'Template1': 'Leeg',
	'Template2': 'Titel 1 bij 2',
	'Template3': '2 boven 1',
	'Template4': '4 boven 1',
	'Template5': 'Voettekst 1 bij 2',
	'Template6': '3 naast 1 boven 1',
	'Template7': '4 naast 3 boven 1',
	'Template8': '2 boven 3 bij 2',
	'Template9': '2 bij 2',
	'Template10': '1 bij 2 naast 2 bij 2 boven 1',
	'Template11': '3 bij 1 boven 1 bij 2',
	'Template12': '2 boven 1 naast 1 bij 2',
	'Template13': 'Een naast 1 bij 2 naast 1 bij 4',
	'Template22': '1 boven 2 bij 2',
	'Template14': '1 naast 1',
	'Template15': '1 boven 1 naast 1',
	'Template16': '1 naast 1 boven 1',
	'Template17': '1 boven 1 naast 1 boven 1',
	'Template18': '1 boven 1 naast 1',
	'Template19': '1 boven 2 naast 1',
	'Template20': '1 boven 2 bij 1',
	'Template21': '1 boven 1 boven 2 bij 1',
	'Template23': 'Leeg met neerzetgebied',
	'Infographics1': 'Leeg',
	'Infographics2': '4 rijen',
	'Infographics3': '4 rijen met kopteksten',
	'Infographics4': '2 bij 4',
	'Infographics5': 'Groot vlak bovenaan met 2 bij 2',
	'Infographics6': '2 bij 4 met verticale tussenruimte',
	'Infographics7': '2 bij 4 gespreid',
	'Infographics8': 'Tennisbaan',
	'Infographics9': '3 bij 4',
	'Infographics10': '4 bij 8',
	'createAvDashboardLabel': 'Layout',
	'dashboard_template_save_success': 'Uw dashboardsjabloon is opgeslagen.',
	'dashboard_template_prefix': 'Sjabloon: "%{name}"',
	'dashboard_template_filters_removed': 'Filters op het canvas zijn verwijderd.',
	'createAvTabLabel': 'Met tabs',
	'createAvInfographicsLabel': 'Infographic',
	'createAvSinglepageLabel': 'Enkele pagina',
	'createAvCustomLabel': 'Aangepast',
	'loadMoreLabel': 'Meer laden ...',
	'backLabel': 'Teruggaan',
	'addSourceLabel': 'Een bron toevoegen',
	'pinLabel': 'Vastzetten',
	'errorLoadingDataSetMetaData': 'Er is een fout opgetreden bij het lezen van de metagegevens',
	'errorLoadingDataSets': 'Er is een fout opgetreden bij het laden van de lijst van gegevenssets',
	'errorLoadingDataSet': 'De metagegevens voor gegevensset "%{datasetName}" zijn niet geladen. Neem contact op met de beheerder voor meer informatie.',
	'okButton': 'OK',
	'createButton': 'Maken',
	'cancelButton': 'Annuleren',
	'copyButton': 'Kopiëren',
	'selectTemplateLabel': 'Sjabloon selecteren',
	'createBoardTitle': 'Dashboard maken',
	'createBoardSubtitle': 'Selecteer een sjabloon voor uw dashboard',
	'noSourcesSelectedLabel': 'Geen bronnen geselecteerd',
	'find_label': 'Zoeken',
	'noDashboardFound': 'Het dashboard kan niet worden opgehaald. Het object bestaat niet meer of u beschikt niet over de machtiging om het te bekijken.',
	'errorLabel': 'Fout',
	'defaultName': 'Nieuw dashboard',
	'noDashboardCapability': 'U hebt bent niet bevoegd voor het uitvoeren van de dashboardtoepassing',
	'noCapabilityForCreateDashboard': 'U hebt niet de vereiste mogelijkheid om een dashboard te maken met de geselecteerde activa',
	'noCapabilityForEdit': 'U hebt niet de mogelijkheid om dit dashboard te bewerken',
	'noCapabilityForSave': 'U hebt niet de mogelijkheid om dit dashboard op te slaan',
	'noCapabilityForPaste': 'U hebt niet de mogelijkheid om gekopieerde widgets in deze view te plakken',
	'noCapabilityForPin': 'U hebt niet de mogelijkheid om deze pin toe te voegen',
	'noCapabilityForLaunchInExplore': 'U hebt niet de mogelijkheid om gekopieerde widgets te starten in een verkenning',
	'noDashboardPermission': 'U hebt onvoldoende bevoegdheden om dit dashboard te bekijken',
	'sourceNotFound': 'De visualisatie kan niet worden geladen omdat de bijbehorende bron "%{sourceName}" niet beschikbaar is',
	'cmDuplicateName': 'Er bestaat al een item met deze naam. Probeer een andere naam',
	'cmEmptySelection': 'Het dashboard is gewist. Probeer het op te slaan als een nieuw dashboard.',
	'propTheme_v1': 'Visueel thema',
	'propTheme': 'Thema',
	'legacyThemeLabel': 'Legacy',
	'carbonGrey10Label': 'Carbon X licht',
	'carbonGrey100Label': 'Carbon X donker',
	'titleTextLabel': 'Titel',
	'titleSmallTextLabel': 'Kleine titel',
	'subtitleTextLabel': 'Onderschrift',
	'bodyTextLabel': 'Tekst',
	'bodySmallTextLabel': 'Kleine tekst',
	'captionTextLabel': 'Bijschrift',
	'quoteTextLabel': 'Aanhaling',
	'quoteSmallTextLabel': 'Klein citaat',
	'responsiveTextLabel': 'Formaat automatisch wijzigen',
	'mediaWidgetLabel': 'Media',
	'webpageWidgetLabel': 'Webpagina',
	'imageWidgetLabel': 'Afbeelding',
	'textWidgetLabel': 'Tekst',
	'notebookWidgetLabel': 'Notebook',
	'multipurposeWidgetLabel': 'Multifunctioneel',
	'textPlaceHolder': 'Klik om tekst te bewerken',
	'titlePlaceHolder': 'Klik om de titel de wijzigen',
	'toggleEditModeLabel': 'Overschakelen naar bewerken',
	'togglePreviewModeLabel': 'Overschakelen naar preview',
	'editDashboardCoachMarkTitle': 'Dashboard bewerken',
	'editDashboardCoachMarkContents': 'Klik op het potloodpictogram om dit dashboard te bewerken.',
	'addDataCoachMarkTitle': 'Gegevens toevoegen',
	'addDataDashboardCoachMarkContents': 'Sleep gegevens vanuit het gegevensscherm naar uw dashboard.',
	'pageSelectWarning': 'Selecteer een tab.',
	'screenshot_label': 'Dashboard %{title}',
	'screenshot_label_tab': 'Tab %{tabName} van dashboard %{title}',
	'dataAssetPropertiesLabel': 'Eigenschappen van visualisatie',
	'modelFilter': 'Filteren',
	'invertSelectionToolTip': 'Filterselecties inverteren',
	'clearFilterValueToolTip': 'Filterwaarden wissen',
	'invertFilterSelection': 'Inverteren',
	'clearTextFilterValue': 'Verwijderen',
	'filterConditionLabel': 'Filtervoorwaarde',
	'applyFilter': 'Filter toepassen',
	'itemCountText': '%{itemCount} item(s) geselecteerd',
	'itemExcludeCountText': '%{itemCount} item(s) uitgesloten',
	'moreMembers': 'Meer afbeelden...',
	'searchHierarchyMembers': 'Gebruik een zoekactie om leden te vinden...',
	'propHideEmpty': 'Lege items verbergen',
	'propColorOrder': 'Kleurvolgorde',
	'propElementColor': 'Kleur visualisatie-element',
	'propLineColor': 'Lijnkleur',
	'propLineAndSymbolColor': 'Kleur van lijnen en symbolen',
	'propColumnColor': 'Kolomkleur',
	'propBarColor': 'Staafkleur',
	'propWordColor': 'Woordkleur',
	'propAreaColor': 'Kleur van oppervlakte',
	'propRadialbarColor': 'Kleur radiaalstaaf',
	'propColorPalettes': 'Kleurenpaletten',
	'propDashboardColorPalette': 'Huidig dashboardpalet',
	'propNewDashboardPaletteLabel': 'Aangepast dashboardpalet maken',
	'propDashboardChangePaletteLink': 'Dashboardpalet wijzigen',
	'propHideLeafNode': 'Voorlooplabels verbergen',
	'propOpacity_v1': 'Ondoorzichtigheid van de widget',
	'propOpacity': 'Ondoorzichtigheid van de widget (%)',
	'propOpacityDescription': 'Het object meer of minder ondoorzichtig maken. Typ een waarde tussen 0 en 100',
	'addATab': 'Nieuwe tab toevoegen',
	'propFredIsRed': 'Kleurconsistentie',
	'areaChartCaption': 'Oppervlak',
	'areaChartDataSlot_categoriesLabel': 'As-label',
	'areaChartDataSlot_valuesLabel': 'Waarde',
	'areaChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'areaChartProp_lineColorLabel': 'Kleur van oppervlakte',
	'areaChartProp_interpolationLabel': 'Vloeiende lijnen',
	'areaChartProp_interpolationDescription': 'De lijnen tussen de gegevenspunten zijn gebogen.',
	'areaChartProp_hideGridLinesLabel': 'Rasterlijnen verbergen',
	'areaChartProp_hideGridLinesDescription': 'Rasterlijnen verbergen',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Labels van astitels verbergen',
	'areaChartProp_hideAxisTitleLabelsDescription': 'De titels van de assen verbergen.',
	'areaChartProp_maintainAxisScalesLabel': 'Asschaal handhaven',
	'areaChartProp_maintainAxisScalesDescription': 'De minimum- en maximumwaarden altijd afbeelden op de assen',
	'areaChartProp_suppressZerosLabel': 'Lege items verbergen',
	'areaChartProp_suppressZerosDescription': 'Categorieën zonder bijbehorende waarden verbergen.',
	'barChartCaption': 'Staaf',
	'barChartDataSlot_categoriesLabel': 'As-label',
	'barChartDataSlot_valuesLabel': 'Waarde',
	'barChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'barChartProp_elementColorLabel': 'Staafkleur',
	'barChartProp_hideGridLinesLabel': 'Rasterlijnen verbergen',
	'barChartProp_hideGridLinesDescription': 'Rasterlijnen verbergen',
	'barChartProp_hideAxisTitleLabelsLabel': 'Labels van astitels verbergen',
	'barChartProp_hideAxisTitleLabelsDescription': 'De titels van de assen verbergen.',
	'barChartProp_maintainAxisScalesLabel': 'Asschaal handhaven',
	'barChartProp_maintainAxisScalesDescription': 'De minimum- en maximumwaarden altijd afbeelden op de assen',
	'barChartProp_suppressZerosLabel': 'Lege items verbergen',
	'barChartProp_suppressZerosDescription': 'Categorieën zonder bijbehorende waarden verbergen.',
	'columnChartCaption': 'Kolom',
	'columnChartDataSlot_categoriesLabel': 'As-label',
	'columnChartDataSlot_valuesLabel': 'Waarde',
	'columnChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'columnChartProp_elementColorLabel': 'Kolomkleur',
	'columnChartProp_hideGridLinesLabel': 'Rasterlijnen verbergen',
	'columnChartProp_hideGridLinesDescription': 'Rasterlijnen verbergen',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Labels van astitels verbergen',
	'columnChartProp_hideAxisTitleLabelsDescription': 'De titels van de assen verbergen.',
	'columnChartProp_maintainAxisScalesLabel': 'Asschaal handhaven',
	'columnChartProp_maintainAxisScalesDescription': 'De minimum- en maximumwaarden altijd afbeelden op de assen',
	'columnChartProp_suppressZerosLabel': 'Lege items verbergen',
	'columnChartProp_suppressZerosDescription': 'Categorieën zonder bijbehorende waarden verbergen.',
	'bubbleChartCaption': 'Bellen',
	'bubbleChartDataSlot_xAxisLabel': 'Horizontale as',
	'bubbleChartDataSlot_yAxisLabel': 'Verticale as',
	'bubbleChartDataSlot_sizeLabel': 'Grootte op basis van',
	'bubbleChartDataSlot_colorLabel': 'Kleur op basis van',
	'bubbleChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'bubbleChartProp_hideGridLinesLabel': 'Rasterlijnen verbergen',
	'bubbleChartProp_hideGridLinesDescription': 'Rasterlijnen verbergen',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Labels van astitels verbergen',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'De titels van de assen verbergen.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Asschaal handhaven',
	'bubbleChartProp_maintainAxisScalesDescription': 'De minimum- en maximumwaarden altijd afbeelden op de assen',
	'bubbleChartProp_hideLegendLabel': 'Legenda verbergen',
	'bubbleChartProp_hideLegendDescription': 'De legenda verbergen.',
	'bubbleChartProp_legendPositionLabel': 'Positie van legenda',
	'lineChartCaption': 'Lijn',
	'lineChartDataSlot_categoriesLabel': 'As-label',
	'lineChartDataSlot_valuesLabel': 'Waarde',
	'lineChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'lineChartProp_lineColorLabel': 'Kleur van lijnen en symbolen',
	'lineChartProp_symbolShapeLabel': 'Symboolvorm',
	'lineChartProp_hideSymbolsLabel': 'Symbolen verbergen',
	'lineChartProp_hideSymbolsDescription': 'Symbolen verbergen',
	'lineChartProp_hideDataLinesLabel': 'Lijn(en) verbergen',
	'lineChartProp_hideDataLinesDescription': 'Lijn(en) verbergen',
	'lineChartProp_interpolationLabel': 'Vloeiende lijnen',
	'lineChartProp_interpolationDescription': 'De lijnen tussen de gegevenspunten zijn gebogen.',
	'lineChartProp_hideGridLinesLabel': 'Rasterlijnen verbergen',
	'lineChartProp_hideGridLinesDescription': 'Rasterlijnen verbergen',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Labels van astitels verbergen',
	'lineChartProp_hideAxisTitleLabelsDescription': 'De titels van de assen verbergen.',
	'lineChartProp_maintainAxisScalesLabel': 'Asschaal handhaven',
	'lineChartProp_maintainAxisScalesDescription': 'De minimum- en maximumwaarden altijd afbeelden op de assen',
	'lineChartProp_suppressZerosLabel': 'Lege items verbergen',
	'lineChartProp_suppressZerosDescription': 'Categorieën zonder bijbehorende waarden verbergen.',
	'packedBubbleChart1CatCaption': 'Gecomprimeerde bellen',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Categorieën',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Grootte op basis van',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Kleurenpaletten',
	'packedBubbleChart1CatProp_elementColorLabel': 'Kleur van bel',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Label verbergen',
	'packedBubbleChart1CatProp_hideValueLabel': 'Waarde verbergen',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Asschaal handhaven',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'De minimum- en maximumwaarden altijd afbeelden op de assen',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Lege items verbergen',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Categorieën zonder bijbehorende waarden verbergen.',
	'heatChartCaption': 'Heatmap',
	'heatChartDataSlot_valuesLabel': 'Heat op basis van',
	'heatChartDataSlot_xAxisLabel': 'Horizontale as',
	'heatChartDataSlot_yAxisLabel': 'Verticale as',
	'heatChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'heatChartProp_heatScalePaletteLabel': 'Kleurvolgorde',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Labels van astitels verbergen',
	'heatChartProp_hideAxisTitleLabelsDescription': 'De titels van de assen verbergen.',
	'heatChartProp_maintainAxisScalesLabel': 'Asschaal handhaven',
	'heatChartProp_maintainAxisScalesDescription': 'De minimum- en maximumwaarden altijd afbeelden op de assen',
	'heatChartProp_suppressZerosLabel': 'Lege items verbergen',
	'heatChartProp_suppressZerosDescription': 'Categorieën zonder bijbehorende waarden verbergen.',
	'heatChartProp_hideLegendLabel': 'Legenda verbergen',
	'heatChartProp_hideLegendDescription': 'De legenda verbergen.',
	'heatChartProp_legendPositionLabel': 'Positie van legenda',
	'pieChartCaption': 'Cirkeldiagram',
	'pieChartDataSlot_categoriesLabel': 'Categorieën',
	'pieChartDataSlot_valuesLabel': 'Waarde',
	'pieChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'pieChartProp_hideRadialValueLabel': 'Waarde verbergen',
	'pieChartProp_pieAsDonutLabel': 'Afbeelden als donutdiagram',
	'pieChartProp_pieAsDonutDescription': 'Afbeelden als donutdiagram',
	'pieChartProp_suppressZerosLabel': 'Lege items verbergen',
	'pieChartProp_suppressZerosDescription': 'Categorieën zonder bijbehorende waarden verbergen.',
	'pieChartProp_hideLegendLabel': 'Legenda verbergen',
	'pieChartProp_hideLegendDescription': 'De legenda verbergen.',
	'pieChartProp_legendPositionLabel': 'Positie van legenda',
	'map1measureCaption': 'Kaart',
	'map1measureDataSlot_categoriesLabel': 'Regio\'s',
	'map1measureDataSlot_valuesLabel': 'Hitte van regio',
	'map1measureProp_colorPaletteLabel': 'Kleurenpaletten',
	'map1measureProp_heatScalePaletteLabel': 'Kleurvolgorde',
	'map1measureProp_maintainAxisScalesLabel': 'Asschaal handhaven',
	'map1measureProp_maintainAxisScalesDescription': 'De minimum- en maximumwaarden altijd afbeelden op de assen',
	'map1measureProp_suppressZerosLabel': 'Lege items verbergen',
	'map1measureProp_suppressZerosDescription': 'Categorieën zonder bijbehorende waarden verbergen.',
	'map1measureProp_hideLegendLabel': 'Legenda verbergen',
	'map1measureProp_hideLegendDescription': 'De legenda verbergen.',
	'map1measureProp_legendPositionLabel': 'Positie van legenda',
	'radialChartCaption': 'Radiaal ',
	'radialChartDataSlot_categoriesLabel': 'Categorieën',
	'radialChartDataSlot_valuesLabel': 'Waarde',
	'radialChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'radialChartProp_elementColorLabel': 'Kleur radiaalstaaf',
	'radialChartProp_hideRadialTitleLabel': 'Titel verbergen',
	'radialChartProp_hideRadialValueLabel': 'Waarde verbergen',
	'radialChartProp_maintainAxisScalesLabel': 'Asschaal handhaven',
	'radialChartProp_maintainAxisScalesDescription': 'De minimum- en maximumwaarden altijd afbeelden op de assen',
	'radialChartProp_suppressZerosLabel': 'Lege items verbergen',
	'radialChartProp_suppressZerosDescription': 'Categorieën zonder bijbehorende waarden verbergen.',
	'pointChart1catCaption': 'Punt',
	'pointChart1catDataSlot_valuesLabel': 'Waarde',
	'pointChart1catDataSlot_categoriesLabel': 'As-label',
	'pointChart1catProp_colorPaletteLabel': 'Kleurenpaletten',
	'pointChart1catProp_elementColorLabel': 'Vormkleur',
	'pointChart1catProp_symbolShapeLabel': 'Symboolvorm',
	'pointChart1catProp_symbolFillLabel': 'Opvulvorm',
	'pointChart1catProp_symbolFillDescription': 'Opvulkleur voor de symbolen.',
	'pointChart1catProp_hideGridLinesLabel': 'Rasterlijnen verbergen',
	'pointChart1catProp_hideGridLinesDescription': 'Rasterlijnen verbergen',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Labels van astitels verbergen',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'De titels van de assen verbergen.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Asschaal handhaven',
	'pointChart1catProp_maintainAxisScalesDescription': 'De minimum- en maximumwaarden altijd afbeelden op de assen',
	'pointChart1catProp_suppressZerosLabel': 'Lege items verbergen',
	'pointChart1catProp_suppressZerosDescription': 'Categorieën zonder bijbehorende waarden verbergen.',
	'scatterPlotChartNoCatCaption': 'Strooidiagram ',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Horizontale as',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Verticale as',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Kleurenpaletten',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Kleuren van elementen',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Symboolvorm',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Opvulvorm',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Opvulkleur voor de symbolen.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Rasterlijnen verbergen',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Rasterlijnen verbergen',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Labels van astitels verbergen',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'De titels van de assen verbergen.',
	'radialBarChartCaption': 'Radiaal staaf',
	'radialBarChartDataSlot_categoriesLabel': 'Categorieën',
	'radialBarChartDataSlot_valuesLabel': 'Waarde',
	'radialBarChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'radialBarChartProp_elementColorLabel': 'Kleur radiaalstaaf',
	'radialBarChartProp_hideRadialTitleLabel': 'Titel verbergen',
	'radialBarChartProp_maintainAxisScalesLabel': 'Asschaal handhaven',
	'radialBarChartProp_maintainAxisScalesDescription': 'De minimum- en maximumwaarden altijd afbeelden op de assen',
	'radialBarChartProp_suppressZerosLabel': 'Lege items verbergen',
	'radialBarChartProp_suppressZerosDescription': 'Categorieën zonder bijbehorende waarden verbergen.',
	'lineColumnComboChartCaption': 'Lijn en kolom',
	'lineColumnComboChartDataSlot_categoryLabel': 'As-label',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Lijnwaarde',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Kolomwaarde',
	'lineColumnComboChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'lineColumnComboChartProp_elementColorLabel': 'Kolomkleur',
	'lineColumnComboChartProp_lineColorLabel': 'Kleur van lijnen en symbolen',
	'lineColumnComboChartProp_symbolShapeLabel': 'Symboolvorm',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Symbolen verbergen',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Symbolen verbergen',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Lijn(en) verbergen',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Lijn(en) verbergen',
	'lineColumnComboChartProp_interpolationLabel': 'Vloeiende lijnen',
	'lineColumnComboChartProp_interpolationDescription': 'De lijnen tussen de gegevenspunten zijn gebogen.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Rasterlijnen verbergen',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Rasterlijnen verbergen',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Labels van astitels verbergen',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'De titels van de assen verbergen.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Asschaal handhaven',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'De minimum- en maximumwaarden altijd afbeelden op de assen',
	'lineColumnComboChartProp_suppressZerosLabel': 'Lege items verbergen',
	'lineColumnComboChartProp_suppressZerosDescription': 'Categorieën zonder bijbehorende waarden verbergen.',
	'lineColumnComboChartProp_hideLegendLabel': 'Legenda verbergen',
	'lineColumnComboChartProp_hideLegendDescription': 'De legenda verbergen.',
	'lineColumnComboChartProp_legendPositionLabel': 'Positie van legenda',
	'summaryCaption': 'Samenvatting',
	'areaName': 'Oppervlak',
	'areaDescription': 'Oppervlak',
	'areaDataSlot_colorLabel': 'Kleur op basis van',
	'areaDataSlot_valuesLabel': 'Waarde',
	'areaDataSlot_categoriesLabel': 'As-label',
	'bubbleName': 'Bellen',
	'bubbleDescription': 'Bellen',
	'bubbleDataSlot_yAxisLabel': 'Verticale as',
	'bubbleDataSlot_xAxisLabel': 'Horizontale as',
	'bubbleDataSlot_sizeLabel': 'Grootte op basis van',
	'bubbleDataSlot_colorLabel': 'Kleur op basis van',
	'clusterBarName': 'Staaf',
	'clusterBarDescription': 'Staaf',
	'clusterBarDataSlot_colorLabel': 'Kleur op basis van',
	'clusterBarDataSlot_valuesLabel': 'Waarde',
	'clusterBarDataSlot_categoriesLabel': 'As-label',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Waarde',
	'clusterColumnName': 'Kolom',
	'clusterColumnDescription': 'Kolom',
	'clusterColumnDataSlot_colorLabel': 'Kleur op basis van',
	'clusterColumnDataSlot_valuesLabel': 'Waarde',
	'clusterColumnDataSlot_categoriesLabel': 'As-label',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Waarde',
	'clusterLineName': 'Lijn',
	'clusterLineDescription': 'Lijn',
	'clusterLineDataSlot_colorLabel': 'Kleur op basis van',
	'clusterLineDataSlot_valuesLabel': 'Verticale as',
	'clusterLineDataSlot_categoriesLabel': 'Horizontale as',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Waarde',
	'gridName': 'Raster',
	'gridDescription': 'Raster',
	'gridDataSlot_grid_colsLabel': 'Kolom',
	'heatName': 'Heatmap',
	'heatDescription': 'Heatmap',
	'heatDataSlot_yAxisLabel': 'Verticale as',
	'heatDataSlot_xAxisLabel': 'Horizontale as',
	'heatDataSlot_valuesLabel': 'Heat op basis van',
	'lineColumnComboName': 'Lijn en kolom',
	'lineColumnComboDescription': 'Lijn en kolom',
	'lineColumnComboDataSlot_lineValueLabel': 'Lijnwaarde',
	'lineColumnComboDataSlot_categoryLabel': 'As-label',
	'lineColumnComboDataSlot_columnValueLabel': 'Kolomwaarde',
	'mapName': 'Legacykaart',
	'mapDescription': 'Legacykaart',
	'mapDataSlot_sizeLabel': 'Lettergrootte',
	'mapDataSlot_valuesLabel': 'Hitte van regio',
	'mapDataSlot_sizeHeatLabel': 'Hitte van punt',
	'mapDataSlot_categoriesLabel': 'Regio\'s',
	'packedBubbleName': 'Gecomprimeerde bellen',
	'packedBubbleDescription': 'Gecomprimeerde bellen',
	'packedBubbleDataSlot_sizeLabel': 'Grootte op basis van',
	'packedBubbleDataSlot_colorLabel': 'Kleur op basis van',
	'packedBubbleDataSlot_categoriesLabel': 'Categorieën',
	'pieName': 'Cirkeldiagram',
	'pieDescription': 'Cirkeldiagram',
	'pieDataSlot_valuesLabel': 'Waarde',
	'pieDataSlot_categoriesLabel': 'Categorieën',
	'playerName': 'Gegevensspeler',
	'playerDescription': 'Gegevensspeler',
	'playerDataSlot_categoriesLabel': 'As-label',
	'pointName': 'Punt',
	'pointDescription': 'Punt',
	'pointDataSlot_colorLabel': 'Kleur op basis van',
	'pointDataSlot_valuesLabel': 'Waarde',
	'pointDataSlot_categoriesLabel': 'As-label',
	'radialName': 'Radiaal ',
	'radialDescription': 'Radiaal ',
	'radialDataSlot_valuesLabel': 'Waarde',
	'radialDataSlot_maxSizeLabel': 'Maximumwaarde',
	'radialDataSlot_categoriesLabel': 'Categorieën',
	'radialBarName': 'Radiaal staaf',
	'radialBarDescription': 'Radiaal staaf',
	'radialBarDataSlot_valuesLabel': 'Waarde',
	'radialBarDataSlot_categoriesLabel': 'Categorieën',
	'scatterPlotName': 'Strooidiagram ',
	'scatterPlotDescription': 'Strooidiagram ',
	'scatterPlotDataSlot_yAxisLabel': 'Verticale as',
	'scatterPlotDataSlot_xAxisLabel': 'Horizontale as',
	'scatterPlotDataSlot_colorLabel': 'Kleur op basis van',
	'scatterPlotDataSlot_categoriesLabel': 'Punten',
	'stackedBarName': 'Gestapelde staven',
	'stackedBarDescription': 'Gestapelde staven',
	'stackedBarDataSlot_colorLabel': 'Kleur op basis van',
	'stackedBarDataSlot_valuesLabel': 'Waarde',
	'stackedBarDataSlot_categoriesLabel': 'As-label',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Waarde',
	'stackedColumnName': 'Gestapelde kolommen',
	'stackedColumnDescription': 'Gestapelde kolommen',
	'stackedColumnDataSlot_colorLabel': 'Kleur op basis van',
	'stackedColumnDataSlot_valuesLabel': 'Waarde',
	'stackedColumnDataSlot_categoriesLabel': 'As-label',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Waarde',
	'summaryChartName': 'Samenvatting',
	'summaryChartDescription': 'Samenvatting',
	'summaryChartDataSlot_valuesLabel': 'Waarde',
	'treeMapName': 'Treemap',
	'treeMapDescription': 'Treemap',
	'treeMapDataSlot_colorLabel': 'Heat op basis van',
	'treeMapDataSlot_valuesLabel': 'Grootte op basis van',
	'treeMapDataSlot_categoriesLabel': 'Niveau één',
	'treeMapDataSlot_level3Label': 'Niveau drie',
	'treeMapDataSlot_level2Label': 'Niveau twee',
	'wordCloudName': 'Woordenwolk',
	'wordCloudDescription': 'Woordenwolk',
	'wordCloudDataSlot_colorLabel': 'Kleur op basis van',
	'wordCloudDataSlot_scaleLabel': 'Grootte op basis van',
	'wordCloudDataSlot_wordLabel': 'Woorden',
	'treeMap1Cat1MeasureChartCaption': 'Treemap',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Niveau één',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Grootte op basis van',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Kleurenpaletten',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Asschaal handhaven',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'De minimum- en maximumwaarden altijd afbeelden op de assen',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Lege items verbergen',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Categorieën zonder bijbehorende waarden verbergen.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Legenda verbergen',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'De legenda verbergen.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Positie van legenda',
	'wordChart1Cat1MeasureCaption': 'Woordenwolk',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Woorden',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Grootte op basis van',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Kleurenpaletten',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Woordkleur',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Asschaal handhaven',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'De minimum- en maximumwaarden altijd afbeelden op de assen',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Lege items verbergen',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Categorieën zonder bijbehorende waarden verbergen.',
	'missingDataSetData': 'De gegevens voor deze gegevensset zijn niet beschikbaar. Vernieuw de gegevensset of vraag de beheerder om toegang tot de bron.',
	'hideShowSummaries': 'Overzichten afbeelden/verbergen',
	'crosstabName': 'Kruistabel',
	'value_is_not_available': 'Nvt',
	'swapRowsAndColumns': 'Rijen en kolommen omwisselen.',
	'NoPinsCollected': 'Geen vastgezette visualisaties',
	'pinSearchOld': 'Zoeken naar mijn vastgezette items',
	'pinDeletedToast': 'Vastgezet item is verwijderd',
	'pinAddedToast': 'Vastgezet item is toegevoegd aan Mijn vastgezette items',
	'pinRetrieveError': 'Een of meer vastzettingen kunnen niet worden opgehaald. Probeer het later opnieuw.',
	'pinErrorTitle': 'Fout bij vastzetten',
	'renamePinTooltip': 'Voer een datum in ...',
	'renamePinInvalidText': 'Dit veld is vereist.',
	'pinRemove': 'Verwijderen',
	'deletePin': 'Het vastgezette item wissen',
	'renamePin': 'Naam wijzigen',
	'cancelRenamePin': 'Annuleren',
	'confirmRenamePin': 'Gereed',
	'dataset_time': 'tijd',
	'dataset_date': 'datum',
	'dataset_location': 'locatie',
	'dataset_number': 'aantal',
	'dataset_text': 'tekst',
	'widgetConditionalFormatLabel': 'Besturingsfuncties voor voorwaardelijke indeling in-/uitschakelen',
	'deletePinConfirmationMessage': 'Weet u zeker dat u dit vastgezette item wilt wissen? Dit kan niet meer ongedaan worden gemaakt.',
	'deletePinConfirm': 'Wissen bevestigen',
	'pinDeleteError': 'Een of meer vastzettingen kunnen niet worden gewist. Probeer het later opnieuw.',
	'metadataPickerTitle': 'Gegevensset maken',
	'moreTitle': 'Meer',
	'remove_slider_handle': 'Hendel verwijderen',
	'missingFiltering': 'Ontbrekende kolom:',
	'unSupportedPromptType': 'Het promptscenario wordt niet ondersteund.',
	'preAggregateLabel': 'Promptwaarden uit de gegevensbron toepassen',
	'postAggregateLabel': 'Promptwaarden toepassen in het rapport',
	'preAggregateText': 'Het bereik maakt gebruik van de waarden in de gegevensbron, niet van de waarden die in het dashboard afgebeeld worden.',
	'tabName_general': 'Algemeen', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'Details',
	'tabName_textDetails': 'Tekstgegevens', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'Mediagegevens', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'Gegevens webpagina', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'Afbeeldingsgegevens', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'Visualisatie',
	'sectionName_canvas': 'Canvas',
	'sectionName_colorsAndThemes_v1': 'Kleur en thema',
	'sectionName_colorsAndThemes': 'Thema & achtergrond',
	'colorsAndThemes_legacyWarning': 'Het huidige dashboard gebruikt een thema uit een eerdere release. Door het wijzigen van het thema en het opslaan van het dashboard wordt toegang tot eerdere themapaletten verwijderd.',
	'sectionName_details': 'Details',
	'sectionName_positionAndStyle': 'Positie & stijl',
	'sectionName_appearance': 'Presentatie', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'Geavanceerd',
	'sectionName_layout': 'Layout', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'Tablabels',
	'sectionName_tabTitle': 'Label',
	'sectionName_tabBackground': 'Achtergrond',
	'addDataSourceDialogTitle': 'Een gegevensbron toevoegen',
	'addDataSourceDialogButtonLabel': 'Toevoegen',
	'shapesDoubleChevron': 'Dubbele chevron',
	'widgetsPanelTitle': 'Widgets',
	'widgetsPanelBasicsTab': 'Basisfuncties',
	'widgetsPanelImageLibraryTab': 'Afbeeldingen',
	'widgetsPanelSectionStandard': 'Standaard',
	'widgetsPanelSectionAdvanced': 'Geavanceerd',
	'widgetsPanelSectionShapes': 'Vormen',
	'customWidgetsTitle': 'Aangepaste widgets',
	'filterItemCanvasMove': 'Aan canvas toevoegen',
	'filterOverflowMenu_Global': 'Overloopmenu voor alle tabs',
	'filterOverflowMenu_Tab': 'Overloopmenu voor deze tab',
	'filterOverflowMenu_Item': 'Overloopmenu voor filter',
	'filterOverflowMenu_Single': 'Overloopmenu',
	'filterItemEdit': 'Filterwaarden bewerken',
	'filterDeleteAllItems': 'Alle filters wissen',
	'filterClearAllItems': 'Alle filters leegmaken',
	'filterClearSelection': 'Filter wissen',
	'filterPlayerMode': 'Speler afbeelden',
	'filterStaticMode': 'Lijst afbeelden',
	'filterInvertSelection': 'Filter inverteren',
	'filterIconLabel_Global': 'Alle tabs',
	'filterIconLabel_Single': 'Filters',
	'filterIconLabel_Tab': 'Deze tab',
	'filterIconTooltip_Global': 'Alle tabs',
	'filterIconTooltip_Tab': 'Deze tab',
	'filterIconTooltip_Single': 'Filters',
	'filterItemDelete': 'Filter wissen',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'alles behalve: %{from}-%{to}',
	'filterExcept': 'behalve %{values}',
	'filterAll': 'Alle',
	'filterBlank': '(blanco)',
	'filterDisableRangeInvert': 'Niet beschikbaar wanneer deze kolom in het filter "Alle tabs" staat.',
	'filterDisableHierarchyInvert': 'Niet beschikbaar als deze kolom een hiërarchiefilter is.',
	'filterSelectedOfTotal': '%{selected} van %{totalMembers}',
	'filter_date_before': 'Voor %{to}',
	'filter_date_before_except': 'Niet voor %{to}',
	'filter_date_after': 'Na %{from}',
	'filter_date_after_except': 'Niet na %{from}',
	'filter_date_between': 'Tussen %{from}-%{to}',
	'filter_date_between_except': 'Niet tussen %{from}-%{to}',
	'filter_drag_and_drop_all_tabs': 'Gegevens hiernaartoe verslepen om alle tabs te filteren',
	'filter_drag_and_drop_current_tab': 'Gegevens hiernaartoe verslepen om deze tab te filteren',
	'filter_drag_and_drop_single_dock': 'Gegevens hiernaartoe verslepen om deze te filteren',
	'errMsgFilterItemGenericTitle': 'Filterwaarden kunnen niet geladen worden',
	'widgetChromeRotate': 'Draaien',
	'toolbarRegionLabel': 'Werkbalk',
	'toolbarActionDelete': 'Verwijderen',
	'toolbarActionGroup': 'Groeperen',
	'toolbarActionUngroup': 'Groepering opheffen',
	'toolbarActionOrderToFront': 'Naar voorgrond',
	'toolbarActionOrderToBack': 'Naar achtergrond',
	'toolbarActionEditTitle': 'De titel bewerken',
	'toolbarActionWrapTitle': 'Titel terug laten lopen',
	'toolbarActionPin': 'Verzamelen',
	'toolbarActionPinOld': 'Vastzetten',
	'toolbarActionAlign': 'Uitlijnen',
	'alignWidgetLeft': 'Links',
	'alignWidgetCenter': 'Midden',
	'alignWidgetRight': 'Rechts',
	'alignWidgetTop': 'Bovenaan',
	'alignWidgetMiddle': 'Midden',
	'alignWidgetBottom': 'Onderaan',
	'distributeWidgetsVertical': 'Verticaal distribueren',
	'distributeWidgetsHoriz': 'Horizontaal distribueren',
	'toolbarChangeVisualization': 'Visualisatie wijzigen',
	'multipurposeHeader': 'Selecteer een widgettype',
	'multipurposePlaceholderText': 'Selecteer een van de widgets om te beginnen.',
	'live_label': 'Diagram',
	'filter_label': 'Filteren',
	'one_named_live': '%{name}-diagram',
	'one_named_live_numbered': '%{name} diagram (%{number})',
	'one_unknown_live': 'Diagram',
	'one_unknown_live_numbered': 'Diagram (%{number})',
	'few_live': 'Groep van %{count} diagrammen',
	'many_live': 'Groep van %{count} diagrammen',
	'one_custom': 'Aangepaste widget',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': '%{name} filter',
	'one_named_filter_numbered': '%{name} filter (%{number})',
	'one_unknown_filter': 'Filteren',
	'one_unknown_filter_numbered': 'Filteren (%{number})',
	'few_filter': 'Groep van %{count} filters',
	'many_filter': 'Groep van %{count} filters',
	'LIVE_bar_has_mapping': '%{values} staafdiagram',
	'LIVE_bar_has_mapping_numbered': '%{values} staafdiagram (%{number})',
	'LIVE_bar_opt_mapping': '%{categories} per %{values} staafdiagram',
	'LIVE_bar_opt_mapping_numbered': '%{categories} per %{values} staafdiagram (%{number})',
	'LIVE_bar_no_mapping': 'Leeg staafdiagram',
	'LIVE_bar_no_mapping_numbered': 'Leeg staafdiagram (%{number})',
	'LIVE_bar_named': '%{name} staafdiagram',
	'LIVE_bar_named_numbered': '%{name} staafdiagram (%{number})',
	'LIVE_stacked_bar_has_mapping': '%{values} gestapeld staafdiagram',
	'LIVE_stacked_bar_has_mapping_numbered': '%{values} gestapeld staafdiagram (%{number})',
	'LIVE_stacked_bar_opt_mapping': '%{categories} per %{values} gestapeld staafdiagram',
	'LIVE_stacked_bar_opt_mapping_numbered': '%{categories} per %{values} gestapeld staafdiagram (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Leeg gestapeld staafdiagram',
	'LIVE_stacked_bar_no_mapping_numbered': 'Leeg gestapeld staafdiagram (%{number})',
	'LIVE_stacked_bar_named': '%{name} gestapeld staafdiagram',
	'LIVE_stacked_bar_named_numbered': '%{name} gestapeld staafdiagram (%{number})',
	'LIVE_bubble_has_mapping': '%{categories} per %{x} en %{y} bellendiagram',
	'LIVE_bubble_has_mapping_numbered': '%{categories} per %{x} en %{y} bellendiagram (%{number})',
	'LIVE_bubble_no_mapping': 'Leeg bellendiagram',
	'LIVE_bubble_no_mapping_numbered': 'Leeg bellendiagram (%{number})',
	'LIVE_bubble_named': '%{name} bellendiagram',
	'LIVE_bubble_named_numbered': '%{name} bellendiagram (%{number})',
	'LIVE_composite_has_mapping': '%{categories} per %{columnValue} en %{lineValue} samengesteld diagram',
	'LIVE_composite_has_mapping_numbered': '%{categories} per %{columnValue} en %{lineValue} samengesteld diagram (%{number})',
	'LIVE_composite_no_mapping': 'Leeg samengesteld diagram',
	'LIVE_composite_no_mapping_numbered': 'Leeg samengesteld diagram (%{number})',
	'LIVE_composite_named': '%{name} samengesteld diagram',
	'LIVE_composite_named_numbered': '%{name} samengesteld diagram (%{number})',
	'LIVE_decision_tree_has_mapping': '%{values} beslissingsstructuur',
	'LIVE_decision_tree_has_mapping_numbered': '%{values} beslissingsstructuur (%{number})',
	'LIVE_decision_tree_no_mapping': 'Lege beslissingsstructuur',
	'LIVE_decision_tree_no_mapping_numbered': 'Lege beslissingsstructuur (%{number})',
	'LIVE_decision_tree_named': '%{name} beslissingsstructuur',
	'LIVE_decision_tree_named_numbered': '%{name} beslissingsstructuur (%{number})',
	'LIVE_packed_bubble_has_mapping': '%{categories} gecomprimeerd bellendiagram',
	'LIVE_packed_bubble_has_mapping_numbered': '%{categories} gecomprimeerd bellendiagram (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Leeg gecomprimeerd bellendiagram',
	'LIVE_packed_bubble_no_mapping_numbered': 'Leeg gecomprimeerd bellendiagram (%{number})',
	'LIVE_packed_bubble_named': '%{name} gecomprimeerd bellendiagram',
	'LIVE_packed_bubble_named_numbered': '%{name} gecomprimeerd bellendiagram (%{number})',
	'LIVE_pie_has_mapping': '%{categories} per %{values} cirkeldiagram',
	'LIVE_pie_has_mapping_numbered': '%{categories} per %{values} cirkeldiagram (%{number})',
	'LIVE_pie_no_mapping': 'Leeg cirkeldiagram',
	'LIVE_pie_no_mapping_numbered': 'Leeg cirkeldiagram (%{number})',
	'LIVE_pie_named': '%{name} cirkeldiagram',
	'LIVE_pie_named_numbered': '%{name} cirkeldiagram (%{number})',
	'LIVE_pie_as_donut_has_mapping': '%{categories} per %{values} ringdiagram',
	'LIVE_pie_as_donut_has_mapping_numbered': '%{categories} per %{values} ringdiagram (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Leeg ringdiagram',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Leeg ringdiagram (%{number})',
	'LIVE_pie_as_donut_named': '%{name} ringdiagram',
	'LIVE_pie_as_donut_named_numbered': '%{name} ringdiagram (%{number})',
	'LIVE_line_has_mapping': '%{categories} per %{values} lijndiagram',
	'LIVE_line_has_mapping_numbered': '%{categories} per %{values} lijndiagram (%{number})',
	'LIVE_line_no_mapping': 'Leeg lijndiagram',
	'LIVE_line_no_mapping_numbered': 'Leeg lijndiagram (%{number})',
	'LIVE_line_named': '%{name} lijndiagram',
	'LIVE_line_named_numbered': '%{name} lijndiagram (%{number})',
	'LIVE_area_has_mapping': '%{categories} per %{values} oppervlaktediagram',
	'LIVE_area_has_mapping_numbered': '%{categories} per %{values} oppervlaktediagram (%{number})',
	'LIVE_area_no_mapping': 'Leeg oppervlaktediagram',
	'LIVE_area_no_mapping_numbered': 'Leeg oppervlaktediagram (%{number})',
	'LIVE_area_named': '%{name} oppervlaktediagram',
	'LIVE_area_named_numbered': '%{name} oppervlaktediagram (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': '%{categories} per %{values} procentueel gestapeld oppervlaktediagram',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': '%{categories} per %{values} procentueel gestapeld oppervlaktediagram (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Leeg procentueel gestapeld oppervlaktediagram',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Leeg procentueel gestapeld oppervlaktediagram (%{number})',
	'LIVE_area_as_stacked_percent_named': '%{name} procentueel gestapeld oppervlaktediagram',
	'LIVE_area_as_stacked_percent_named_numbered': '%{name} procentueel gestapeld oppervlaktediagram (%{number})',
	'LIVE_heatmap_has_mapping': '%{color} heatmap',
	'LIVE_heatmap_has_mapping_numbered': '%{color} heatmap (%{number})',
	'LIVE_heatmap_no_mapping': 'Lege heatmap',
	'LIVE_heatmap_no_mapping_numbered': 'Lege heatmap (%{number})',
	'LIVE_heatmap_named': '%{name} heatmap',
	'LIVE_heatmap_named_numbered': '%{name} heatmap (%{number})',
	'LIVE_network_opt_mapping': '%{categories} per %{series} en %{values} netwerk',
	'LIVE_network_opt_mapping_numbered': '%{categories} per %{series} en %{values} netwerk (%{number})',
	'LIVE_network_has_mapping': '%{categories} per %{series}  netwerk',
	'LIVE_network_has_mapping_numbered': '%{categories} per %{series} netwerk (%{number})',
	'LIVE_network_no_mapping': 'Leeg netwerk',
	'LIVE_network_no_mapping_numbered': 'Leeg netwerk (%{number})',
	'LIVE_network_named': '%{name} netwerk',
	'LIVE_network_named_numbered': '%{name} netwerk (%{number})',
	'LIVE_radial_bar_opt_mapping': '%{categories} per %{values} radiaal staafdiagram',
	'LIVE_radial_bar_opt_mapping_numbered': '%{categories} per %{values} radiaal staafdiagram (%{number})',
	'LIVE_radial_bar_has_mapping': '%{values} radiaal staafdiagram',
	'LIVE_radial_bar_has_mapping_numbered': '%{values} radiaal staafdiagram (%{number})',
	'LIVE_radial_bar_no_mapping': 'Leeg radiaal staafdiagram',
	'LIVE_radial_bar_no_mapping_numbered': 'Leeg radiaal staafdiagram (%{number})',
	'LIVE_radial_bar_named': '%{name} radiaal staafdiagram',
	'LIVE_radial_bar_named_numbered': '%{name} radiaal staafdiagram (%{number})',
	'LIVE_spiral_has_mapping': '%{values} spiraaldiagram',
	'LIVE_spiral_has_mapping_numbered': '%{values} spiraaldiagram (%{number})',
	'LIVE_spiral_no_mapping': 'Leeg spiraaldiagram',
	'LIVE_spiral_no_mapping_numbered': 'Leeg spiraaldiagram (%{number})',
	'LIVE_spiral_named': '%{name} spiraaldiagram',
	'LIVE_spiral_named_numbered': '%{name} spiraaldiagram (%{number})',
	'LIVE_treemap_has_mapping': '%{categories} per %{size} treemap',
	'LIVE_treemap_has_mapping_numbered': '%{categories} per %{size} treemap (%{number})',
	'LIVE_treemap_no_mapping': 'Lege treemap',
	'LIVE_treemap_no_mapping_numbered': 'Lege treemap (%{number})',
	'LIVE_treemap_named': '%{name} treemap',
	'LIVE_treemap_named_numbered': '%{name} treemap (%{number})',
	'LIVE_wordcloud_has_mapping': '%{categories} woordenwolk',
	'LIVE_wordcloud_has_mapping_numbered': '%{categories} woordenwolk (%{number})',
	'LIVE_wordcloud_no_mapping': 'Lege woordenwolk',
	'LIVE_wordcloud_no_mapping_numbered': 'Lege woordenwolk (%{number})',
	'LIVE_wordcloud_named': '%{name} woordenwolk',
	'LIVE_wordcloud_named_numbered': '%{name} woordenwolk (%{number})',
	'LIVE_data_player_has_mapping': '%{category} gegevensspeler',
	'LIVE_data_player_has_mapping_numbered': '%{category} gegevensspeler (%{number})',
	'LIVE_data_player_no_mapping': 'Lege gegevensspeler',
	'LIVE_data_player_no_mapping_numbered': 'Lege gegevensspeler (%{number})',
	'LIVE_data_player_named': '%{name} gegevensspeler',
	'LIVE_data_player_named_numbered': '%{name} gegevensspeler (%{number})',
	'LIVE_map_has_mapping': '%{locations} kaart',
	'LIVE_map_has_mapping_numbered': '%{locations} kaart (%{number})',
	'LIVE_map_no_mapping': 'Lege kaart',
	'LIVE_map_no_mapping_numbered': 'Lege kaart (%{number})',
	'LIVE_map_named': '%{name} kaart',
	'LIVE_map_named_numbered': '%{name} kaart (%{number})',
	'LIVE_point_has_mapping': '%{categories} per %{values} puntdiagram',
	'LIVE_point_has_mapping_numbered': '%{categories} per %{values} puntdiagram (%{number})',
	'LIVE_point_no_mapping': 'Leeg puntdiagram',
	'LIVE_point_no_mapping_numbered': 'Leeg puntdiagram (%{number})',
	'LIVE_point_named': '%{name} puntdiagram',
	'LIVE_point_named_numbered': '%{name} puntdiagram (%{number})',
	'LIVE_column_has_mapping': '%{values} kolomdiagram',
	'LIVE_column_has_mapping_numbered': '%{values} kolomdiagram (%{number})',
	'LIVE_column_opt_mapping': '%{categories} per %{values} kolomdiagram',
	'LIVE_column_opt_mapping_numbered': '%{categories} per %{values} kolomdiagram (%{number})',
	'LIVE_column_no_mapping': 'Leeg kolomdiagram',
	'LIVE_column_no_mapping_numbered': 'Leeg kolomdiagram (%{number})',
	'LIVE_column_named': '%{name} kolomdiagram',
	'LIVE_column_named_numbered': '%{name} kolomdiagram (%{number})',
	'LIVE_stacked_column_has_mapping': '%{values} gestapeld kolomdiagram',
	'LIVE_stacked_column_has_mapping_numbered': '%{values} gestapeld kolomdiagram (%{number})',
	'LIVE_stacked_column_opt_mapping': '%{categories} per %{values} gestapeld kolomdiagram',
	'LIVE_stacked_column_opt_mapping_numbered': '%{categories} per %{values} gestapeld kolomdiagram (%{number})',
	'LIVE_stacked_column_no_mapping': 'Leeg gestapeld kolomdiagram',
	'LIVE_stacked_column_no_mapping_numbered': 'Leeg gestapeld kolomdiagram (%{number})',
	'LIVE_stacked_column_named': '%{name} gestapeld kolomdiagram',
	'LIVE_stacked_column_named_numbered': '%{name} gestapeld kolomdiagram (%{number})',
	'LIVE_scatter_opt_mapping': '%{categories} per %{x} en %{y} strooidiagram',
	'LIVE_scatter_opt_mapping_numbered': '%{categories} per %{x} en %{y} strooidiagram (%{number})',
	'LIVE_scatter_has_mapping': '%{x} vs %{y} strooidiagram',
	'LIVE_scatter_has_mapping_numbered': '%{x} vs %{y} strooidiagram (%{number})',
	'LIVE_scatter_no_mapping': 'Leeg strooidiagram',
	'LIVE_scatter_no_mapping_numbered': 'Leeg strooidiagram (%{number})',
	'LIVE_scatter_named': '%{name} strooidiagram',
	'LIVE_scatter_named_numbered': '%{name} strooidiagram (%{number})',
	'LIVE_waterfall_has_mapping': '%{values} watervaldiagram',
	'LIVE_waterfall_has_mapping_numbered': '%{values} watervaldiagram (%{number})',
	'LIVE_waterfall_no_mapping': 'Leeg watervaldiagram',
	'LIVE_waterfall_no_mapping_numbered': 'Leeg watervaldiagram (%{number})',
	'LIVE_waterfall_named': '%{name} watervaldiagram',
	'LIVE_waterfall_named_numbered': '%{name} watervaldiagram (%{number})',
	'LIVE_empty_visualization_hint_title': 'Uw visualisatie samenstellen',
	'LIVE_empty_visualization_hint_description': 'Kolommen hiernaartoe of naar de slots aan de linkerkant verslepen',
	'LIVE_slots_required_field_description': '%{asterisk} Geeft een verplicht veld aan',
	'LIVE_slots_drag_and_drop_description': 'Versleep de gegevens naar de bovenstaande slots om de visualisatie samen te stellen en te filteren.',
	'requiredField': 'Vereist veld',
	'fullScreenEnter': 'Volledig scherm inschakelen',
	'fullScreenClose': 'Volledig scherm afsluiten',
	'noExtraText_multipurpose': 'Multifunctionele plaatshouder',
	'noExtraText_multipurpose_numbered': 'Multifunctionele plaatshouder (%{number})',
	'one_placeholder_vis': 'Visualisatieplaatshouder',
	'one_placeholder_vis_numbered': 'Visualisatieplaatshouder (%{number})',
	'one_placeholder_text': 'Tekstplaatshouder',
	'one_placeholder_text_numbered': 'Tekstplaatshouder (%{number})',
	'few_placeholder_text': 'Groep van %{count} tekstplaatshouders',
	'many_placeholder_text': 'Groep van %{count} tekstplaatshouders',
	'filter_includesAll': 'Inclusief alle',
	'timeline_filter_moved_to': 'Tijdlijnfilter %{id} verplaatst naar %{time}',
	'timelineSettingsButton': 'Afspeelopties',
	'autoPlay': 'Alle scènes afspelen',
	'loop': 'Herhalen',
	'noSceneTransitionLabel': 'Geen',
	'sceneTransitionPropertyLabel': 'Scèneovergang',
	'animatedPathSceneTransitionLabel': 'Geanimeerd pad',
	'sweepSceneTransitionLabel': 'Opschoning',
	'propAniAnimation': 'Animatie',
	'propAniTypeEntrance': 'Ingangsanimatie',
	'propAniDirectionIn': 'Ingangsrichting',
	'propAniTypeExit': 'Uitgangsanimatie',
	'propAniDirectionOut': 'Uitgangsrichting',
	'propAniDirection': 'Richting',
	'timelineAnimationProperties': 'Eigenschappen voor animatie openen',
	'editStoryCoachMarkTitle': 'Story bewerken',
	'editStoryCoachMarkContents': 'Klik op het potloodpictogram om deze story te bewerken.',
	'addDataStoryCoachMarkContents': 'Sleep gegevens vanuit het gegevensscherm naar uw story.',
	'expandSceneCoachmarkTitle': 'Tijdschema openen',
	'expandSceneCoachmarkContents': 'Een scène animeren door de zichtbaarheid van een object aan te passen aan tijd en datum.',
	'overviewCoachmarkTitle': 'Overzichtsscènes',
	'overviewCoachmarkContents': 'Met de overzichtsscènes aan het begin en eind van uw story kunt u het algehele beeld van alle scènes presenteren. Vanuit een overzichtsscène klikt en sleept u een scène om hem te verwisselen met een andere scène. U kunt de overzichtsscènes afbeelden of verbergen in de eigenschappen van de story.',
	'animatedPathCoachmarkTitle': 'Geanimeerd pad',
	'animatedPathCoachmarkContents': 'Om een object van de ene scène naar een andere te animeren, dupliceert u een scène met een object. Verplaats, vergroot/verklein of roteer het gedupliceerde object vervolgens in de nieuwe scène.',
	'tabName_animation': 'Animatie',
	'textWidgetIconPlaceholderText': 'Klik om tekst toe te voegen',
	'buildVisHeader': 'Een visualisatie maken',
	'visIconPlaceholderText': 'Versleep velden om een visualisatie samen te stellen',
	'launchNewExplore': 'Nieuwe verkenning',
	'addTo': 'Toevoegen aan',
	'addToExisting': 'Toevoegen aan bestaande...',
	'exploreData': 'Verkennen',
	'explore_remove_widget_styles': 'Aangepaste visualisatie-eigenschappen, zoals kleurinstellingen, blijven niet bewaard in uw verkenning.',
	'editNotebook': 'Widget bewerken',
	'thumbnails_error_fetching': 'Fout bij het ophalen van miniaturen',
	'copy': '%{count} asset(s) gekopieerd',
	'specConvertErr': 'Er is een fout opgetreden bij het plakken of converteren van de dashboardspecificatie',
	'specCopyErr': 'Fout bij kopiëren van dashboardspecificatie',
	'pasteNotSupportedErr': 'Plakken vanuit een %{name} wordt niet ondersteund.',
	'reportParam': 'rapport',
	'filterWidgetCopyWarn': 'Filtervisualisatie is niet gekopieerd, want filters worden op dit moment niet ondersteund.',
	'upgradingDashboard': '"%{name}" upgraden voor %{version}...',
	'upgradeComplete': 'Upgrade voltooid',
	'individualTabProperties': 'Eigenschappen van afzonderlijke tabs',
	'propMasterTabStylesLabel_v1': 'Algemene stijl van het tabblad',
	'propMasterTabStylesLabel': 'Stijl van alle tabbladen',
	'propTabPosition': 'Tabpositie',
	'propTabTitle': 'Titel',
	'propTabBackgroundColor': 'Opvulkleur',
	'propTabTextColor': 'Kleur titel',
	'propTabSelectedBarColor': 'Kleur van geselecteerde staaf',
	'propTabRestoreDefaults': 'Standaardwaarden herstellen',
	'propIndividualTabStylesLabel': 'Stijl van afzonderlijke tabs',
	'propIndividualTabStylesAriaLabel': 'Eigenschappen van stijl voor afzonderlijke tabs openen',
	'propTabIconPosition': 'Pictogrampositie',
	'propLeftTitle': 'Links van titel',
	'propRightTitle': 'Rechts van titel',
	'propTopTitle': 'Boven titel',
	'propBottomTitle': 'Onder titel',
	'propTabIconLabel': 'Visueel',
	'propTabIcon': 'Pictogram',
	'propTabIconColor': 'Pictogramkleur',
	'no_icon': 'Leeg',
	'announcement': 'Aankondiging',
	'api': 'API',
	'archive': 'Archiveren',
	'asset': 'Asset',
	'attachment': 'Bijlage',
	'audio': 'Audio',
	'bee': 'Bij',
	'blog': 'Blog',
	'bookmark': 'Bladwijzer',
	'calendar': 'Kalender',
	'camera': 'Camera',
	'capability': 'Mogelijkheid',
	'catalog': 'Catalogus',
	'chat_message': 'Chatbericht',
	'checkout_cart': 'Wagentje afrekenen',
	'client': 'Client',
	'clock': 'Klok',
	'cloud': 'Wolk',
	'code': 'Code',
	'data_quality': 'Gegevenskwaliteit',
	'folder': 'Mappen',
	'forum': 'Forum',
	'glasses': 'Bril',
	'group': 'Groeperen',
	'hat': 'Hoed',
	'headphone': 'Hoofdtelefoon',
	'hills': 'Heuvels',
	'home': 'Home',
	'idea': 'Idee',
	'image': 'Afbeelding',
	'inventory': 'Inventaris',
	'like': 'Like',
	'link': 'Koppeling',
	'location': 'Locatie',
	'manage': 'Beheren',
	'pen': 'Pen',
	'mobile_phone': 'Mobiele telefoon',
	'music': 'Muziek',
	'notifications': 'Meldingen',
	'paint': 'Verf',
	'payment': 'Betaling',
	'password_key': 'Wachtwoordsleutel',
	'people': 'Personen',
	'person': 'Persoon',
	'phone': 'Telefoon',
	'pin': 'Vastzetten',
	'print': 'Afdrukken',
	'recording': 'Opname',
	'repository': 'Repository',
	'role': 'Rol',
	'search': 'Zoeken',
	'properties': 'Eigenschappen',
	'speaker': 'Luidspreker',
	'star': 'Ster',
	'tag': 'Code',
	'thumbs_up': 'Duim omhoog',
	'thumbs_down': 'Duim omlaag',
	'tools': 'Tools',
	'traffic': 'Verkeer',
	'trash': 'Prullenbak',
	'twitter': 'Twitter',
	'unknown': 'Onbekend',
	'user': 'Gebruiker',
	'venn_diagram': 'Venn-diagram',
	'video': 'Video',
	'view': 'Beeld',
	'warning': 'Waarschuwing',
	'watch': 'Bekijken',
	'watson': 'Watson',
	'wikis': 'Wiki\'s',
	'workspace': 'Werkgebied',
	'world': 'Wereld',
	'eventGroupButtonLabel': 'Verbindingen met widget bekijken',
	'dockToolbar': 'Werkbalk koppelen',
	'undockToolbar': 'Werkbalk loskoppelen',
	'propShowTitle': 'Titel afbeelden',
	'textAutoFontSize': 'Automatisch',
	'zoomFitToWidth': 'Aan breedte aanpassen',
	'zoomWholePage': 'Passend maken op pagina',
	'defaultZoomValue': 'Standaard zoomwaarde',
	'zoomCategoryLabel': 'Pagina in-/uitzoomen (alleen absolute indeling)'
});
